import React, {useContext} from "react";
import {FormGroup, Label, Input, FormText, FormFeedback, Col} from 'reactstrap';
import LangContext from "../../../providers/LangContext";

const CheckboxGroup = ({id, name, description, value, options, onChange, terms, required, errors}) => {
    const { lang } = useContext(LangContext);
    const parseTerms = (checkboxText) => {
        if(checkboxText.search('[terms]') < 0) {
            return checkboxText;
        }

        let termsArray = checkboxText.split('[terms]')
        const conditions = lang.get(
            "sites.bieding_terms_url",
            {
                termsLink: terms
            }
        );

        termsArray.splice(1,0,conditions);
        return termsArray.join('');
    }
    return (
        <FormGroup className="mb-2">
            <FormGroup check className="my-1">
                <Label check
                       className={`${!!errors ? ' is-invalid ' : ' '}`}
                >
                    <Input
                        type="checkbox"
                        name={name}
                        onChange={e => {
                            onChange(id, {
                                [e.target.name]: e.target.checked ? 'true' : 'false'
                            });
                        }}
                    />{" "}
                    <span dangerouslySetInnerHTML={{__html: parseTerms(description)}}/>{!!required && '*'}
                </Label>
                {!!errors ? <FormFeedback className="d-block">{errors[0]}</FormFeedback> : ''}
            </FormGroup>
        </FormGroup>
    );
};

export default CheckboxGroup;
